"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getUtils;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _excluded = ["requestName", "redirect", "go", "timeOut"];
function getUtils(context) {
  var wapp = context.wapp,
    req = context.req,
    res = context.res;
  function historyPush(_ref) {
    var _response$requestName, _response$requestName2;
    var redirect = _ref.redirect,
      go = _ref.go,
      response = _ref.response,
      requestName = _ref.requestName,
      timeOut = _ref.timeOut;
    if (response && !((_response$requestName = response[requestName]) !== null && _response$requestName !== void 0 && _response$requestName.error) && typeof ((_response$requestName2 = response[requestName]) === null || _response$requestName2 === void 0 ? void 0 : _response$requestName2.record) !== "undefined") {
      if (go) {
        if (timeOut) {
          setTimeout(function () {
            wapp.client.history.go(go);
          }, timeOut);
        } else {
          wapp.client.history.go(go);
        }
        return;
      }
      if (redirect) {
        var _response$requestName3;
        var parsedUrl = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, typeof redirect == "object" ? redirect : {}), {}, {
          pathname: typeof redirect == "string" ? redirect : redirect.pathname
        });
        if (parsedUrl.pathname && (_response$requestName3 = response[requestName].record) !== null && _response$requestName3 !== void 0 && _response$requestName3._id) {
          parsedUrl.pathname = parsedUrl.pathname.replace(":_id", response[requestName].record._id);
        }
        if (timeOut) {
          setTimeout(function () {
            wapp.client.history.push(parsedUrl);
          }, timeOut);
        } else {
          wapp.client.history.push(parsedUrl);
        }
      }
    }
  }
  return {
    getGlobalState: function getGlobalState(p) {
      return res.wappResponse.store.getState(p);
    },
    getRequestUrl: function getRequestUrl() {
      return this.getGlobalState("req.url");
    },
    getRequestUser: function getRequestUser() {
      var user = this.getGlobalState("req.user");
      return user !== null && user !== void 0 && user._id ? user : null;
    },
    logout: function () {
      var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
        var p,
          _p$requestName,
          requestName,
          _p$redirect,
          redirect,
          go,
          timeOut,
          response,
          _args = arguments;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              p = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _p$requestName = p.requestName, requestName = _p$requestName === void 0 ? "userLogout" : _p$requestName, _p$redirect = p.redirect, redirect = _p$redirect === void 0 ? "/" : _p$redirect, go = p.go, timeOut = p.timeOut;
              _context.next = 4;
              return wapp.requests.send({
                requestName: requestName,
                req: req,
                res: res
              });
            case 4:
              response = _context.sent;
              historyPush({
                redirect: redirect,
                go: go,
                response: response,
                requestName: requestName,
                timeOut: timeOut
              });
              return _context.abrupt("return", response[requestName] || response);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    login: function () {
      var _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
        var p,
          _p$requestName2,
          requestName,
          args,
          _p$redirect2,
          redirect,
          go,
          timeOut,
          response,
          _args2 = arguments;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              p = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              _p$requestName2 = p.requestName, requestName = _p$requestName2 === void 0 ? "userLogin" : _p$requestName2, args = p.args, _p$redirect2 = p.redirect, redirect = _p$redirect2 === void 0 ? "/user/:_id" : _p$redirect2, go = p.go, timeOut = p.timeOut;
              _context2.next = 4;
              return wapp.requests.send({
                requestName: requestName,
                args: args,
                req: req,
                res: res
              });
            case 4:
              response = _context2.sent;
              historyPush({
                redirect: redirect,
                go: go,
                response: response,
                requestName: requestName,
                timeOut: timeOut
              });
              return _context2.abrupt("return", response[requestName] || response);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function login() {
        return _login.apply(this, arguments);
      }
      return login;
    }(),
    signup: function () {
      var _signup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
        var p,
          _p$requestName3,
          requestName,
          args,
          _p$redirect3,
          redirect,
          go,
          timeOut,
          response,
          _args3 = arguments;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              p = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
              _p$requestName3 = p.requestName, requestName = _p$requestName3 === void 0 ? "userSignup" : _p$requestName3, args = p.args, _p$redirect3 = p.redirect, redirect = _p$redirect3 === void 0 ? "/user/:_id" : _p$redirect3, go = p.go, timeOut = p.timeOut;
              _context3.next = 4;
              return wapp.requests.send({
                requestName: requestName,
                args: args,
                req: req,
                res: res
              });
            case 4:
              response = _context3.sent;
              historyPush({
                redirect: redirect,
                go: go,
                response: response,
                requestName: requestName,
                timeOut: timeOut
              });
              return _context3.abrupt("return", response[requestName] || response);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function signup() {
        return _signup.apply(this, arguments);
      }
      return signup;
    }(),
    sendRequest: function () {
      var _sendRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
        var p,
          _p$requestName4,
          requestName,
          redirect,
          go,
          timeOut,
          rest,
          response,
          _args4 = arguments;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              p = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              _p$requestName4 = p.requestName, requestName = _p$requestName4 === void 0 ? "userForgotPassword" : _p$requestName4, redirect = p.redirect, go = p.go, timeOut = p.timeOut, rest = (0, _objectWithoutProperties2["default"])(p, _excluded);
              _context4.next = 4;
              return wapp.requests.send((0, _objectSpread2["default"])({
                requestName: requestName,
                req: req,
                res: res
              }, rest));
            case 4:
              response = _context4.sent;
              historyPush({
                redirect: redirect,
                go: go,
                response: response,
                requestName: requestName,
                timeOut: timeOut
              });
              return _context4.abrupt("return", response && response[requestName] || response);
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function sendRequest() {
        return _sendRequest.apply(this, arguments);
      }
      return sendRequest;
    }()
  };
}